/**
 * Falken cart notify + Custom Cut fee add.
 * IMPORTANT: sheet + cutting fee are added in ONE /cart/add.js request
 * so the fee cannot be dropped by the old 1s delayed second call.
 */
(function () {
  var CUT_VARIANT_ID = 42731011014884; // product: cut-to-size / Custom Cut fee variant

  function showCartNotification() {
    var el = document.getElementById("NotificationSuccess");
    if (!el) return;
    el.setAttribute("aria-hidden", "false");
    el.classList.add("notification--active");
    window.clearTimeout(window.__falkenNotifyTimer);
    window.__falkenNotifyTimer = window.setTimeout(function () {
      el.classList.remove("notification--active");
      el.setAttribute("aria-hidden", "true");
    }, 10000);
  }

  function hideCartNotification() {
    var el = document.getElementById("NotificationSuccess");
    if (!el) return;
    el.classList.remove("notification--active");
    el.setAttribute("aria-hidden", "true");
  }

  function ensureNotify() {
    window.theme = window.theme || {};
    if (window.theme.Notify) return;
    if (window.themeLodash && typeof window.themeLodash.map === "function") {
      window._ = window.themeLodash;
    }
    if (typeof window.Notify === "function") {
      try {
        window.theme.Notify = new window.Notify();
      } catch (error) {}
    }
  }

  function openSuccessNotification() {
    ensureNotify();
    try {
      if (window.theme && window.theme.Notify && typeof window.theme.Notify.open === "function") {
        window.theme.Notify.open("success", false, true);
        return;
      }
    } catch (error) {}
    showCartNotification();
  }

  /** Theme bubble uses .site-header__cart-indicator (not .cart-item-count). */
  function refreshCartIndicator(cart) {
    var $ = window.jQuery;
    if (!$ || !cart) return;
    var count = Number(cart.item_count) || 0;
    var $badge = $(
      ".site-header__cart-indicator, .cart-item-count, .cart__count, [data-cart-count], .js-cart-count",
    );
    if (!$badge.length) return;
    $badge.text(String(count));
    if (count > 0) $badge.removeClass("hide");
    else $badge.addClass("hide");
  }

  function refreshCartIndicatorFromServer() {
    var $ = window.jQuery;
    if (!$ || !$.getJSON) return;
    $.getJSON("/cart.js")
      .done(refreshCartIndicator)
      .fail(function () {});
  }

  function getCutFeeQuantity() {
    var $ = window.jQuery;
    if (!$ || !$(".cut-item").length) return 0;
    var cutCount = 0;
    $(".cut-item").each(function () {
      var fromData = Number($(this).find(".cut-data").val()) || 0;
      if (fromData > 0) {
        cutCount += fromData;
        return;
      }
      // Fallback if cut-data wasn't committed yet but the piece row is filled
      var qty = Number($(this).find(".product-form__quantity").val()) || 0;
      var width = Number($(this).find(".product-form__width").val()) || 0;
      var length = Number($(this).find(".product-form__length").val()) || 0;
      var fractionW = Number($(this).find(".fraction__width").val()) || 0;
      var fractionL = Number($(this).find(".fraction__length").val()) || 0;
      if (qty > 0 && width + fractionW > 0 && length + fractionL > 0) cutCount += qty;
    });
    return cutCount;
  }

  /** Build Shopify cart items[] from product form + optional cut fee. */
  function buildItemsFromForm($form, cutCount) {
    var $ = window.jQuery;
    var items = [];
    var id =
      Number($form.find('[name="id"]').val()) ||
      Number($form.find('input[name="id"]:checked').val()) ||
      Number($form.find("#ProductSelect-" + ($form.data("section") || "")).val());
    var qty = Number($form.find('[name="quantity"]').val()) || 1;
    if (!id) return items;

    var properties = {};
    $form.find('[name^="properties["]').each(function () {
      var name = this.getAttribute("name") || "";
      var m = name.match(/^properties\[(.*)\]$/);
      if (!m) return;
      var val = this.value;
      if (val === "" || val == null) return;
      // Skip empty placeholder cut props
      if (m[1].indexOf("Custom Cut: 0 X 0") === 0) return;
      if (String(val) === "0" && m[1].indexOf("Custom Cut:") === 0) return;
      properties[m[1]] = val;
    });

    var sheetItem = { id: id, quantity: qty };
    if (Object.keys(properties).length) sheetItem.properties = properties;
    items.push(sheetItem);

    if (cutCount > 0) {
      items.push({ id: CUT_VARIANT_ID, quantity: cutCount });
    }
    return items;
  }

  function addItemsToCart(items, onSuccess, onError) {
    var $ = window.jQuery;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      contentType: "application/json",
      dataType: "json",
      success: onSuccess,
      error: function (xhr) {
        // Fallback: sequential adds if theme/Shopify rejects items[] payload
        if (!items.length) return onError && onError(xhr);
        var i = 0;
        function next(err) {
          if (err) return onError && onError(err);
          if (i >= items.length) return onSuccess && onSuccess();
          var item = items[i++];
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: item,
            dataType: "json",
            success: function () {
              next();
            },
            error: next,
          });
        }
        next();
      },
    });
  }

  window.falkenAddCutFeeWithForm = function ($form, opts) {
    opts = opts || {};
    var $ = window.jQuery;
    if (typeof window.falkenValidateAllCuts === "function" && !window.falkenValidateAllCuts(true)) {
      return false;
    }
    var cutCount = getCutFeeQuantity();
    var items = buildItemsFromForm($form, cutCount);
    if (!items.length) return false;

    addItemsToCart(
      items,
      function () {
        if (opts.clearCuts !== false) {
          $(".cut-item").each(function () {
            $(this).find(".remove-cut_item").click();
            $(".cut-message").removeClass("active");
          });
        }
        openSuccessNotification();
        refreshCartIndicatorFromServer();
        if (typeof opts.onSuccess === "function") opts.onSuccess();
      },
      function (err) {
        if (typeof opts.onError === "function") opts.onError(err);
        else if (window.console) console.error("Falken cart add failed", err);
      },
    );
    return true;
  };

  /** Custom-pieces path: explicit sheet variant(s) + optional cutting fee. */
  window.falkenAddCustomPiecesOrder = function (payload, opts) {
    opts = opts || {};
    var $ = window.jQuery;
    var items = [];
    if (!payload) return false;

    if (payload.sheetItems && payload.sheetItems.length) {
      payload.sheetItems.forEach(function (line, idx) {
        if (!line || !line.id) return;
        var item = { id: Number(line.id), quantity: Number(line.quantity) || 1 };
        // Persist cut dims + customer acknowledgment on the first sheet line
        if (
          idx === 0 &&
          payload.properties &&
          Object.keys(payload.properties).length
        ) {
          item.properties = payload.properties;
        }
        items.push(item);
      });
    } else if (payload.sheetVariantId) {
      var sheetItem = {
        id: Number(payload.sheetVariantId),
        quantity: Number(payload.sheetQuantity) || 1,
      };
      if (payload.properties && Object.keys(payload.properties).length) {
        sheetItem.properties = payload.properties;
      }
      items.push(sheetItem);
    } else {
      return false;
    }

    var feeQty = Number(payload.cutFeeQuantity) || 0;
    if (feeQty > 0) items.push({ id: CUT_VARIANT_ID, quantity: feeQty });

    addItemsToCart(
      items,
      function () {
        openSuccessNotification();
        refreshCartIndicatorFromServer();
        if (typeof opts.onSuccess === "function") opts.onSuccess();
        if (opts.redirectCart) window.location.href = "/cart";
      },
      function (err) {
        if (typeof opts.onError === "function") opts.onError(err);
        else alert("Could not add custom pieces to cart. Please try again.");
      },
    );
    return true;
  };

  function patchAjaxCart() {
    if (!window.AjaxCart || !window.AjaxCart.prototype) return;

    if (!window.AjaxCart.prototype.success.__falkenNotifyPatched) {
      window.AjaxCart.prototype.success = function () {
        openSuccessNotification();
        refreshCartIndicatorFromServer();
        if (this.cache && this.cache.$cartIconIndicator) {
          this.cache.$cartIconIndicator.removeClass("hide");
        }
      };
      window.AjaxCart.prototype.success.__falkenNotifyPatched = true;
    }

    if (!window.AjaxCart.prototype.addItemFromForm.__falkenKerfPatched) {
      var originalAdd = window.AjaxCart.prototype.addItemFromForm;
      window.AjaxCart.prototype.addItemFromForm = function (evt) {
        var $ = window.jQuery;
        evt.preventDefault();
        if ($(".cut-item").length) {
          var self = this;
          var ok = window.falkenAddCutFeeWithForm(this.$form, {
            onSuccess: $.proxy(self.success, self),
            onError: $.proxy(self.error, self),
          });
          if (!ok && typeof originalAdd === "function") return originalAdd.call(this, evt);
          return;
        }
        // No custom-cut rows: use theme add once (theme.js now supports Default Title products).
        if (typeof originalAdd === "function") return originalAdd.call(this, evt);
      };
      window.AjaxCart.prototype.addItemFromForm.__falkenKerfPatched = true;
    }
  }

  function bindUi() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $(document)
      .off("click.falkenNotify", ".notification__continue, #NotificationSuccess .notification__close")
      .on(
        "click.falkenNotify",
        ".notification__continue, #NotificationSuccess .notification__close",
        function (event) {
          event.preventDefault();
          hideCartNotification();
          if (window.theme && window.theme.Notify && typeof window.theme.Notify.close === "function") {
            window.theme.Notify.close();
          }
        },
      );
  }

  function init() {
    ensureNotify();
    patchAjaxCart();
    bindUi();
  }

  function schedule() {
    init();
    window.setTimeout(init, 300);
    window.setTimeout(init, 1500);
    window.setTimeout(init, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }
  window.addEventListener("load", init);
})();
